import React from 'react';

/** Dezentes Gitter — nur leicht erkennbar im Hintergrund. */
export const ArkorbitGridBackground: React.FC<{ className?: string; opacity?: number }> = ({
  className = '',
  opacity = 0.045,
}) => (
  <div
    aria-hidden
    className={`pointer-events-none absolute inset-0 ${className}`}
    style={{
      opacity,
      backgroundImage: `
        linear-gradient(rgba(148, 163, 184, 0.35) 1px, transparent 1px),
        linear-gradient(90deg, rgba(148, 163, 184, 0.35) 1px, transparent 1px)
      `,
      backgroundSize: '1rem 1rem',
    }}
  />
);
